export default "__VITE_ASSET__CIhTaEVz__"